module.exports = __webpack_public_path__ + "img/discount.05de45c1.svg";